// src/components/Admin/AdminPanel.jsx - Versione CORRETTA con Parco Veicoli
import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, orderBy, doc, updateDoc, limit } from 'firebase/firestore';
import { db } from '../../firebase';

// Import componenti gestione personale
import AdminWorkHours from './AdminWorkHours';
import AdminReports from './AdminReports';
import AdminLeaveRequests from './AdminLeaveRequests';
import AdminQRManagement from './AdminQRManagement';
import TimekeepingScanner from '../TimekeepingScanner';
import DeviceRegistration from './DeviceRegistration';
import AdminReportsTable from './AdminReportsTable';
import AdminFilters from './AdminFilters';

// Import componente unificato per gestione utenti, incarichi e costi
import IncarichiManagement from './IncarichiManagement';

// Import sidebar navigation
import AdminSidebarNavigation from './AdminSidebarNavigation';

// Import componenti cantieri (SENZA MezziManagement - spostato in Parco Veicoli)
import CommittentiManagement from './Cantieri/CommittentiManagement';
import CantieriManagement from './Cantieri/CantieriManagement';
import LavorazioniManagement from './Cantieri/LavorazioniManagement';
import MaterialiFissiManagement from './Cantieri/MaterialiFissiManagement';
import MaterialiVariabiliManagement from './Cantieri/MaterialiVariabiliManagement';
import ReportCantieriManagement from './Cantieri/ReportCantieriManagement';

// Import componenti Parco Veicoli
import MezziManagement from './Cantieri/MezziManagement'; // Rimane in Cantieri/
import CapoOfficinaRapportini from '../CapoOfficina/CapoOfficinaRapportini'; // ✅ Riutilizzo componente CapoOfficina

import CalendarioScadenze from './CalendarioScadenze';

import VerificaPersonale from './VerificaPersonale';

// Import CSS
import './AdminSidebarNavigation.css';
import './AdminPanel.css';
import './IncarichiManagement.css';
import SyncRapportiniCosts from './SyncRapportiniCosts';

import QuickTestSync from './QuickTestSync';

const AdminPanel = () => {
  // ==============================
  // STATI PRINCIPALI
  // ==============================
  const [currentSection, setCurrentSection] = useState('personale');
  const [activeTab, setActiveTab] = useState('workHours');

  // Stati per navigazione cantieri
  const [cantieriContext, setCantieriContext] = useState({
    preselectedCommittenteId: null,
    showCreateForm: false,
    selectedCantiereId: null,
    showCantiereDetail: false,
    viewMode: null
  });

  // Stati per navigazione committenti
  const [committentiContext, setCommittentiContext] = useState({
    selectedCommittenteId: null,
    showCommittenteDetail: false,
    viewMode: null
  });

  // Stati per segnalazioni
  const [reports, setReports] = useState([]);
  const [filteredReports, setFilteredReports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    status: 'all',
    type: 'all',
    dateFrom: '',
    dateTo: '',
    searchTerm: ''
  });

  // AGGIUNGI QUESTI NUOVI STATI SUBITO DOPO:
const [showAllReports, setShowAllReports] = useState(false); // Traccia se mostrare tutte
const [totalReportsCount, setTotalReportsCount] = useState(0); // Totale segnalazioni

  // ==============================
  // CONFIGURAZIONE TAB
  // ==============================
  const sectionTabs = {
    personale: [
      { id: 'workHours', label: 'Ore Lavoro', icon: '📊' },
      { id: 'reports', label: 'Segnalazioni', icon: '📝' },
      { id: 'incarichi', label: 'Utenti & Incarichi', icon: '👤' },
      { id: 'leaveRequests', label: 'Permessi', icon: '📋' },
      { id: 'qrManagement', label: 'QR Code', icon: '📱' },
      { id: 'timekeeping', label: 'Timbrature', icon: '⏰' },
      { id: 'devices', label: 'Dispositivi', icon: '📱' },
      { id: 'verifica', label: 'Verifica Personale', icon: '📍' },
      { id: 'download', label: 'Report', icon: '📄' }
    ],
    cantieri: [
      { id: 'committenti', label: 'Committenti', icon: '🏢' },
      { id: 'cantieri', label: 'Cantieri', icon: '🏗️' },
      { id: 'lavorazioni', label: 'Lavorazioni', icon: '⚒️' },
      // RIMOSSO: mezzi
      { id: 'materialiVariabili', label: 'Mat. Variabili', icon: '📦' },
      { id: 'materialiFissi', label: 'Mat. Fissi', icon: '🧱' },
      { id: 'reportCantieri', label: 'Report', icon: '📊' },
      { id: 'syncRapportini', label: 'Sincronizza', icon: '🔄' }
    ],
    parcoVeicoli: [
      { id: 'mezzi', label: 'Mezzi', icon: '🚛' },
      { id: 'rapportiniOfficina', label: 'Rapportini Officina', icon: '🔧' }
    ],
    calendario: [
      { id: 'scadenzario', label: 'Scadenzario', icon: '📅' }
    ]
  };

  // ==============================
  // FUNZIONI NAVIGAZIONE CANTIERI
  // ==============================
  const navigateToCommittenteDetail = (committenteId) => {
    console.log('Navigating to committente detail:', committenteId);
    setCommittentiContext({
      selectedCommittenteId: committenteId,
      showCommittenteDetail: true,
      viewMode: 'detail'
    });
    setCantieriContext({
      preselectedCommittenteId: null,
      showCreateForm: false,
      selectedCantiereId: null,
      showCantiereDetail: false,
      viewMode: null
    });
    setCurrentSection('cantieri');
    setActiveTab('committenti');
  };

  const navigateToCantiereDetail = (cantiereId) => {
    console.log('Navigating to cantiere detail:', cantiereId);
    setCantieriContext({
      preselectedCommittenteId: null,
      showCreateForm: false,
      selectedCantiereId: cantiereId,
      showCantiereDetail: true,
      viewMode: 'detail'
    });
    setCommittentiContext({
      selectedCommittenteId: null,
      showCommittenteDetail: false,
      viewMode: null
    });
    setCurrentSection('cantieri');
    setActiveTab('cantieri');
  };

  const navigateToCantieriWithCommittente = (committenteId) => {
    console.log('Navigating to cantieri with preselected committente:', committenteId);
    setCantieriContext({
      preselectedCommittenteId: committenteId,
      showCreateForm: true,
      selectedCantiereId: null,
      showCantiereDetail: false,
      viewMode: 'create'
    });
    setCommittentiContext({
      selectedCommittenteId: null,
      showCommittenteDetail: false,
      viewMode: null
    });
    setCurrentSection('cantieri');
    setActiveTab('cantieri');
  };

  const navigateBackToCommittente = () => {
    setCommittentiContext({
      selectedCommittenteId: null,
      showCommittenteDetail: false,
      viewMode: null
    });
  };

  const navigateBackToCantieri = () => {
    setCantieriContext({
      preselectedCommittenteId: null,
      showCreateForm: false,
      selectedCantiereId: null,
      showCantiereDetail: false,
      viewMode: 'list'
    });
  };

  // ==============================
  // GESTIONE NAVIGAZIONE
  // ==============================
  const handleSectionChange = (section) => {
    setCurrentSection(section);
    
    if (section === 'personale') {
      setActiveTab('workHours');
      // Reset context cantieri
      setCantieriContext({
        preselectedCommittenteId: null,
        showCreateForm: false,
        selectedCantiereId: null,
        showCantiereDetail: false,
        viewMode: null
      });
      setCommittentiContext({
        selectedCommittenteId: null,
        showCommittenteDetail: false,
        viewMode: null
      });
    } else if (section === 'cantieri') {
      setActiveTab('committenti');
    } else if (section === 'parcoVeicoli') {
      setActiveTab('mezzi'); // Default: tab Mezzi
    } else if (section === 'calendario') {
      setActiveTab('scadenzario');
    }
  };

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
    
    // Reset context quando si cambia tab
    if (tabId !== 'committenti') {
      setCommittentiContext({
        selectedCommittenteId: null,
        showCommittenteDetail: false,
        viewMode: null
      });
    }
    if (tabId !== 'cantieri') {
      setCantieriContext({
        preselectedCommittenteId: null,
        showCreateForm: false,
        selectedCantiereId: null,
        showCantiereDetail: false,
        viewMode: null
      });
    }
  };

// ==============================
// CARICAMENTO SEGNALAZIONI
// ==============================
useEffect(() => {
  const fetchReports = async () => {
    if (activeTab !== 'reports') return;
    
    setIsLoading(true);
    setError(null);
    
    try {
      // Prima: conta il totale delle segnalazioni
      const countQuery = query(collection(db, 'reports'));
      const countSnapshot = await getDocs(countQuery);
      const totalCount = countSnapshot.size;
      setTotalReportsCount(totalCount);
      
      // Poi: carica con o senza limite
      const reportsRef = collection(db, 'reports');
      let reportsQuery;
      
      if (showAllReports) {
        // Carica tutte le segnalazioni
        reportsQuery = query(
          reportsRef,
          orderBy('createdAt', 'desc')
        );
        console.log('AdminPanel: Caricamento di TUTTE le segnalazioni');
      } else {
        // Carica solo le ultime 10
        reportsQuery = query(
          reportsRef,
          orderBy('createdAt', 'desc'),
          limit(10)
        );
        console.log('AdminPanel: Caricamento delle ultime 10 segnalazioni');
      }
      
      const snapshot = await getDocs(reportsQuery);
      const reportsData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      console.log(`AdminPanel: Caricate ${reportsData.length} segnalazioni (totale: ${totalCount})`);
      setReports(reportsData);
      setFilteredReports(reportsData);
    } catch (err) {
      console.error('Errore nel caricamento segnalazioni:', err);
      setError('Errore nel caricamento delle segnalazioni');
    } finally {
      setIsLoading(false);
    }
  };

  fetchReports();
}, [activeTab, showAllReports]); // ✅ Aggiungi showAllReports alle dipendenze

  // ==============================
  // APPLICAZIONE FILTRI
  // ==============================
  useEffect(() => {
    // Se un filtro è attivo e non abbiamo ancora caricato tutto, carica tutte le segnalazioni
    const hasActiveFilters = 
      filters.status !== 'all' || 
      filters.type !== 'all' || 
      filters.searchTerm !== '' || 
      filters.dateFrom !== '' || 
      filters.dateTo !== '';
    
    if (hasActiveFilters && !showAllReports) {
      console.log('AdminPanel: Filtri attivi, caricamento di tutte le segnalazioni...');
      setShowAllReports(true);
      return; // Il nuovo caricamento verrà fatto dall'useEffect precedente
    }
    
    // Applica i filtri sui dati caricati
    let filtered = [...reports];
  
    if (filters.status !== 'all') {
      filtered = filtered.filter(report => report.status === filters.status);
    }
  
    if (filters.type !== 'all') {
      filtered = filtered.filter(report => report.type === filters.type);
    }
  
    if (filters.searchTerm) {
      const searchLower = filters.searchTerm.toLowerCase();
      filtered = filtered.filter(report => 
        report.userName?.toLowerCase().includes(searchLower) ||
        report.description?.toLowerCase().includes(searchLower) ||
        report.userEmail?.toLowerCase().includes(searchLower)
      );
    }
  
    if (filters.dateFrom) {
      const dateFrom = new Date(filters.dateFrom);
      dateFrom.setHours(0, 0, 0, 0);
      filtered = filtered.filter(report => {
        const reportDate = report.createdAt?.toDate() || new Date(report.createdAt);
        return reportDate >= dateFrom;
      });
    }
  
    if (filters.dateTo) {
      const dateTo = new Date(filters.dateTo);
      dateTo.setHours(23, 59, 59, 999);
      filtered = filtered.filter(report => {
        const reportDate = report.createdAt?.toDate() || new Date(report.createdAt);
        return reportDate <= dateTo;
      });
    }
  
    console.log(`AdminPanel: Filtri applicati, ${filtered.length} risultati da ${reports.length} totali`);
    setFilteredReports(filtered);
  }, [filters, reports, showAllReports]);

  // ==============================
  // GESTIONE STATO SEGNALAZIONI
  // ==============================
  const handleStatusUpdate = async (reportId, newStatus) => {
    try {
      const reportRef = doc(db, "reports", reportId);
      await updateDoc(reportRef, { status: newStatus });
      
      setReports(prevReports =>
        prevReports.map(report =>
          report.id === reportId ? { ...report, status: newStatus } : report
        )
      );
    } catch (error) {
      console.error("Errore nell'aggiornamento dello stato:", error);
    }
  };

  // ==============================
  // RENDER CONTENUTO PRINCIPALE
  // ==============================
  const renderContent = () => {
    // SEZIONE PERSONALE
    if (currentSection === 'personale') {
      switch (activeTab) {
        case 'workHours':
          return <AdminWorkHours />;
        
          case 'reports':
            return (
              <div>
                <AdminFilters 
                  filters={filters} 
                  setFilters={setFilters}
                  reports={reports} 
                />
                
                {/* Info e bottone carica tutte */}
                {!showAllReports && totalReportsCount > 10 && (
                  <div style={{
                    background: '#e3f2fd',
                    padding: '12px 20px',
                    borderRadius: '8px',
                    marginBottom: '20px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    border: '1px solid #90caf9'
                  }}>
                    <div style={{ color: '#1565c0', fontSize: '14px' }}>
                      📊 Visualizzate le ultime <strong>10 segnalazioni</strong> su <strong>{totalReportsCount} totali</strong>
                    </div>
                    <button
                      onClick={() => setShowAllReports(true)}
                      style={{
                        background: 'linear-gradient(135deg, #2196F3 0%, #1976D2 100%)',
                        color: 'white',
                        border: 'none',
                        padding: '8px 16px',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '13px',
                        fontWeight: '600',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                      onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                    >
                      📋 Carica tutte le segnalazioni
                    </button>
                  </div>
                )}
                
                {error ? (
                  <div className="error-message">{error}</div>
                ) : isLoading ? (
                  <div style={{ textAlign: 'center', padding: '40px' }}>
                    <div className="spinner"></div>
                    <p>Caricamento segnalazioni...</p>
                  </div>
                ) : (
                  <AdminReportsTable 
                    reports={filteredReports}
                    onStatusChange={handleStatusUpdate}
                  />
                )}
              </div>
            );
        
        case 'incarichi':
          return <IncarichiManagement />;
        
        case 'leaveRequests':
          return <AdminLeaveRequests />;
        
        case 'qrManagement':
          return <AdminQRManagement />;
        
        case 'timekeeping':
          return <TimekeepingScanner />;
        
        case 'devices':
          return <DeviceRegistration />;

          case 'verifica':  // ← NUOVO CASE
        return <VerificaPersonale />;
        
        case 'download':
          return <AdminReports />;
        
        default:
          return <AdminWorkHours />;
      }
    } 
    // SEZIONE CANTIERI
    else if (currentSection === 'cantieri') {
      switch (activeTab) {
        case 'committenti':
          return (
            <CommittentiManagement 
              onCreateCantiere={navigateToCantieriWithCommittente}
              onViewCantiere={navigateToCantiereDetail}
              selectedCommittenteId={committentiContext.selectedCommittenteId}
              showCommittenteDetail={committentiContext.showCommittenteDetail}
              viewMode={committentiContext.viewMode}
            />
          );
        
        case 'cantieri':
          return (
            <CantieriManagement 
              preselectedCommittenteId={cantieriContext.preselectedCommittenteId}
              showCreateForm={cantieriContext.showCreateForm}
              selectedCantiereId={cantieriContext.selectedCantiereId}
              showCantiereDetail={cantieriContext.showCantiereDetail}
              viewMode={cantieriContext.viewMode}
              onBackToCommittente={navigateBackToCommittente}
              onBackToCantieri={navigateBackToCantieri}
            />
          );
        
        case 'lavorazioni':
          return <LavorazioniManagement />;
        
        case 'materialiVariabili':
          return <MaterialiVariabiliManagement />;
        
        case 'materialiFissi':
          return <MaterialiFissiManagement />;
        
        case 'reportCantieri':
          return <ReportCantieriManagement />;

        case 'syncRapportini':
          return <SyncRapportiniCosts />;
        
        default:
          return (
            <CommittentiManagement 
              onCreateCantiere={navigateToCantieriWithCommittente}
              onViewCantiere={navigateToCantiereDetail}
              selectedCommittenteId={committentiContext.selectedCommittenteId}
              showCommittenteDetail={committentiContext.showCommittenteDetail}
              viewMode={committentiContext.viewMode}
            />
          );
      }
    }
    // SEZIONE PARCO VEICOLI
    else if (currentSection === 'parcoVeicoli') {
      switch (activeTab) {
        case 'mezzi':
          return <MezziManagement />;
        
        case 'rapportiniOfficina':
          return <CapoOfficinaRapportini />; // ✅ Componente CapoOfficina riutilizzato
        
        default:
          return <MezziManagement />;
      }
    }

      // SEZIONE CALENDARIO
    else if (currentSection === 'calendario') {
      return <CalendarioScadenze />;
    }
    
    // Fallback
    return <AdminWorkHours />;
  };

  // ==============================
  // DESCRIZIONI SEZIONI
  // ==============================
  const getSectionDescription = (section, tab) => {
    const descriptions = {
      personale: {
        workHours: 'Gestisci le ore lavorative dei dipendenti',
        reports: 'Visualizza e gestisci le segnalazioni del personale',
        incarichi: 'Gestisci utenti, incarichi lavorativi e costi orari',
        leaveRequests: 'Gestisci richieste di permessi, ferie e malattie',
        qrManagement: 'Gestisci codici QR per le timbrature',
        timekeeping: 'Scanner per timbrature manuali',
        devices: 'Gestisci dispositivi registrati per le timbrature',
        verifica: 'Verifica posizioni timbrature e presenza personale',
        download: 'Genera e scarica report del personale'
      },
      cantieri: {
        committenti: 'Gestisci i committenti e i loro dati',
        cantieri: 'Gestisci cantieri e progetti attivi',
        lavorazioni: 'Gestisci tipologie di lavorazioni',
        materialiVariabili: 'Gestisci materiali a costo variabile',
        materialiFissi: 'Gestisci materiali a costo fisso',
        reportCantieri: 'Genera report e analisi cantieri',
        syncRapportini: 'Sincronizza costi rapportini'
      },
      parcoVeicoli: {
        mezzi: 'Gestisci mezzi e attrezzature',
        rapportiniOfficina: 'Gestisci rapportini del capo officina'
      },
      calendario: {
        scadenzario: 'Visualizza scadenze personale e mezzi'
      }
    };

    return descriptions[section]?.[tab] || 'Pannello di amministrazione';
  };

  // Funzioni helper per titoli dinamici
  const getSectionTitle = () => {
    switch (currentSection) {
      case 'personale':
        return '👥 Gestione Personale';
      case 'cantieri':
        return '🏗️ Gestione Cantieri';
      case 'parcoVeicoli':
        return '🚗 Parco Veicoli';
        case 'calendario':
  return '📅 Calendario';
      default:
        return '👥 Gestione Personale';
    }
  };

  const getSectionBadge = () => {
    switch (currentSection) {
      case 'personale':
        return '👥 Personale';
      case 'cantieri':
        return '🏗️ Cantieri';
      case 'parcoVeicoli':
        return '🚗 Veicoli';
      default:
        return '👥 Personale';
    }
  };

  // ==============================
  // RENDER PRINCIPALE
  // ==============================
  return (
    <div className="admin-panel-container">
      {/* SIDEBAR NAVIGATION */}
      <AdminSidebarNavigation
        currentSection={currentSection}
        onSectionChange={handleSectionChange}
      />

      {/* MAIN CONTENT AREA */}
      <div className="admin-layout-with-sidebar">
        <div className="admin-panel">
          {/* HEADER DEL PANNELLO */}
          <div className="admin-panel-header">
            <div className="header-content">
              <h1 className="section-title">
                {getSectionTitle()}
              </h1>
              <p className="section-description">
                {getSectionDescription(currentSection, activeTab)}
              </p>
            </div>
            
            {/* INDICATORE SEZIONE ATTIVA */}
            <div className="section-indicator">
              <span className={`indicator-badge ${currentSection}`}>
                {getSectionBadge()}
              </span>
            </div>
          </div>

          {/* NAVIGATION TABS */}
          <div className="tabs-container">
            <div className={`admin-tabs ${currentSection === 'cantieri' ? 'cantieri-mode' : currentSection === 'parcoVeicoli' ? 'veicoli-mode' : 'personale-mode'}`}>
              {sectionTabs[currentSection].map(tab => (
                <button 
                  key={tab.id}
                  className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                  onClick={() => handleTabChange(tab.id)}
                  title={getSectionDescription(currentSection, tab.id)}
                >
                  <span className="tab-icon">{tab.icon}</span>
                  <span className="tab-label">{tab.label}</span>
                </button>
              ))}
            </div>
          </div>

          {/* CONTENUTO PRINCIPALE */}
          <div className="admin-content">
            <div className="content-wrapper">
              {renderContent()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;